import router from '@/router'
import axios from 'axios'
import {Message} from 'element-ui'
// 创建一个新的axios
const service = axios.create({
    timeout: 100000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        let accessToken = sessionStorage.getItem("pa.accessToken");
		let authCode = sessionStorage.getItem("Authorization");
        let isLogin = config.url.includes('login')

        if(accessToken){
            config.headers['accessToken'] = accessToken;
        }
		if(authCode) {
			config.headers['Authorization'] = authCode;
		}
      //   else if(!isLogin && !config.url.includes('noAuth')){
			// console.info("interceptor request error ")
      //       router.push('/Error')
      //   }
		let channel = localStorage.getItem("pa.channel");
        let canaryFlag = localStorage.getItem("canaryFlag");
		let noCanary = sessionStorage.getItem("noCanary")|| canaryFlag == '1' ? '0' : '1';
        config.headers['channel'] = channel; // 自己的channel 2 为平安
        config.headers['frontend'] = '2';
        config.headers['canary'] = canaryFlag;
		config.headers['no-canary'] = noCanary;
        return config
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        const result = response.data
        /*
        code为非20000或200是抛错 可结合自己业务进行修改
        */

        return result
    },
    error => {
		if (!error.response) {
		    // Message({
		    //     message: '网络错误',
		    //     type: 'error',
		    //     duration: 5 * 1000
		    // });
			console.log('there is no error.response ' )
			return {errorMessage:'网络错误'};
		}
		let resStatus = error.response.data.status;
		if(resStatus === 401 || resStatus === 402){
		    sessionStorage.removeItem('qybAccessToken');
		    sessionStorage.removeItem('pa.accessToken');
		    sessionStorage.removeItem("loginId");
			console.info('401 remove token');
			location.reload();
		}
        if (error.response.data && error.response.data.message) {
		  Message({
			  message: error.response.data.message,
		      type: 'error'
		  });
          return {errorMessage:error.response.data.message};
        }
        console.log('err' + error)
        return Promise.reject(error)
    }
)

export default service
